import React, { useContext, useEffect, useMemo } from "react";
import VideoCard from "../VideoCard";
import { MeetingContext } from "@/pages/Meeting";
import style from "./style.module.scss";

const SpeakerLayout: React.FunctionComponent = () => {
  const { displayParticipants: participants, service } = useContext(MeetingContext);

  const mainParticipant =
    participants.find((d) => d.share) ||
    participants.find((d) => d.active) ||
    participants.find((d) => d.pinned) ||
    participants[1] ||
    participants[0];

  const subParticipant =
    participants.find((d) => {
      if (mainParticipant && mainParticipant.peerId.startsWith("share_")) {
        return d.peerId === mainParticipant.peerId.split("share_")[1];
      }
      return false;
    }) || participants[0];

  const participantIds = useMemo(
    () => participants.map((peer) => peer.peerId).join(","),
    [participants]
  );

  useEffect(() => {
    if (!window.roomClient) {
      return;
    }

    const syncVisibleParticipants = async () => {
      const visiblePeerIds = new Set(
        [mainParticipant, subParticipant]
          .filter((peer) => peer && !peer.local && !peer.share)
          .map((peer) => peer.peerId)
      );

      for (const peer of participants) {
        if (!peer || peer.local || peer.share) {
          continue;
        }

        const visible = visiblePeerIds.has(peer.peerId);
        if (peer.bInActivePage !== visible) {
          await service.setParticipantInActivePage(peer.peerId, visible);
        }
      }
    };

    syncVisibleParticipants();
  }, [participantIds, mainParticipant?.peerId, subParticipant?.peerId, service]);

  return (
    <>
      <div className={style.main}>
        {mainParticipant && <VideoCard participant={mainParticipant} cover showTool={false} />}
      </div>
      <div className={style.sub}>
        {subParticipant && <VideoCard participant={subParticipant} compact />}
      </div>
    </>
  );
};

export default SpeakerLayout;
